import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import shortid from 'shortid'
import get from 'lodash/get'
import find from 'lodash/find'

import colors from 'theme/colors'
import VenueFavouriteHandler from 'enhancers/withFavouriteVenue'
import { DesktopScreen } from 'utils/screen'
import VenueStatusOrange from 'common/VenueStatusOrange'
import {
  HeaderIcon,
  InfoSection,
  InfoSectionRows,
  TagsContainer,
  Tags,
  TagsSeparator,
  VenueName,
  VendorHeaderItemStatus,
  VendorHeaderItemInfo,
  WhiteOverlay,
  Back,
} from './styled'
import { MAX_TAGS_COUNT, TAG_MULTI_VENDOR_TYPE } from 'pages/vendor/const'
import getHistory from 'services/history'
import { isMultiVendor as isMultiVendorEnv } from 'utils/multiVendor'

class VendorHeader extends React.PureComponent {
  render() {
    const { name, tags, id, isOffline, precinct, allTags } = this.props
    const tagsJsx = (tags || [])
      .slice(0, MAX_TAGS_COUNT)
      .reduce(
        (acc, tag) => [
          ...acc,
          <Fragment key={shortid.generate()}>{tag.name}</Fragment>,
          <TagsSeparator key={shortid.generate()}>&bull;</TagsSeparator>,
        ],
        [],
      )
      .filter((x, i, arr) => i !== arr.length - 1)

    const goBack = () =>
      isMultiVendorEnv()
        ? get(precinct, 'tag')
          ? getHistory().push(`/precinct/${get(precinct, 'tag')}`)
          : getHistory().push(
              `/precinct/${get(
                find(allTags, {
                  type: TAG_MULTI_VENDOR_TYPE,
                }),
                'name',
                '',
              )}`,
            )
        : getHistory().length > 1
        ? getHistory().goBack()
        : getHistory().replace('/')

    return (
      <Fragment>
        <VendorHeaderItemStatus isOffline={isOffline}>
          <VenueStatusOrange position="top" />
        </VendorHeaderItemStatus>
        <WhiteOverlay />
        <VendorHeaderItemInfo isOffline={isOffline}>
          <DesktopScreen>
            <HeaderIcon
              onClick={this.props.history.goBack}
              type="arrowLeft"
              size={24}
              fill={colors['gray4']}
            />
          </DesktopScreen>
          <InfoSection>
            <Back onClick={goBack} src="BackDarker.svg" />
            <InfoSectionRows>
              <VenueName>{name}</VenueName>
              {tagsJsx && (
                <TagsContainer>
                  <Tags>{tagsJsx}</Tags>
                </TagsContainer>
              )}
            </InfoSectionRows>
          </InfoSection>
          <DesktopScreen>
            <VenueFavouriteHandler id={id}>
              {({ isFavourite, onClick }) => {
                return (
                  <HeaderIcon
                    onClick={onClick}
                    type="heart"
                    size={24}
                    fill={isFavourite ? colors['primary'] : 'none'}
                    stroke={colors['primary']}
                  />
                )
              }}
            </VenueFavouriteHandler>
          </DesktopScreen>
        </VendorHeaderItemInfo>
      </Fragment>
    )
  }
}

VendorHeader.propTypes = {
  history: PropTypes.object,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ),
  name: PropTypes.string,
}

VendorHeader.defaultProps = {
  tags: [],
}

export default VendorHeader
